import { ONE_DAY } from '@/utils/time'
import { SiteUsageStats } from '@/jsonapi/SiteStats'
import moment from 'moment-timezone'

export function calcStripRevenue(siteUsageStats: SiteUsageStats): number {
  // old method...
  // const REVENUE_PER_STRIP = siteUsageStats.config.glucometerStripRevenue //0.13 // for now
  // let dataPoints = siteUsageStats.glucometerReadings
  //
  // if (dataPoints === 0) {
  //   return 0
  // }
  //
  // return dataPoints * REVENUE_PER_STRIP

  let monthStrings = getSelectedYearMonthsArray(siteUsageStats.queryStartTimestamp, siteUsageStats.queryEndTimestamp)

  return monthStrings
    .map(function(yearMonthString) {
      if (!siteUsageStats.glucometerReadingCountsPerMonthByType || !siteUsageStats.revenuesAndCosts) {
        return 0 // no strip use, or no revenues or costs for this site
      }

      let totalCount = siteUsageStats.glucometerReadingCountsPerMonthByType[yearMonthString]?.totalCount || 0
      let stripRevenue = siteUsageStats.revenuesAndCosts[yearMonthString]?.glucometerStripRevenue || 0
      return totalCount * stripRevenue
    })
    .reduce((acc, val) => acc + val, 0)
}

function getStartAndEndVitalsOrGlucometer(siteUsageStats: SiteUsageStats): [number, number] {
  let vitalsStart = siteUsageStats.config.vitalsStartDate || moment().valueOf()
  let glucometerStart = siteUsageStats.config.glucometerStartDate || moment().valueOf()

  let programStart = Math.min(vitalsStart, glucometerStart)
  // eslint-disable-next-line prettier/prettier
  if (
    programStart >
    moment()
      .subtract(1, 'days')
      .valueOf()
  ) {
    return [0, 0]
  }

  let vitalsEnd = siteUsageStats.config.vitalsEndDate || moment().valueOf()
  let glucometerEnd = siteUsageStats.config.glucometerEndDate || moment().valueOf()

  let programEnd = Math.max(vitalsEnd, glucometerEnd)
  // eslint-disable-next-line prettier/prettier

  // start calculating at the program start, or query start, whichever is later
  let start = Math.max(programStart, siteUsageStats.queryStartTimestamp)

  // stop calculating at the program end, or query end, whichever is earlier
  let end = Math.min(programEnd, siteUsageStats.queryEndTimestamp)

  return [start, end]
}

export function getStartAndEndGlucometer(siteUsageStats: SiteUsageStats): [number, number] {
  let glucometerStart = siteUsageStats.config.glucometerStartDate || moment().valueOf()

  // eslint-disable-next-line prettier/prettier
  if (
    glucometerStart >
    moment()
      .subtract(1, 'days')
      .valueOf()
  ) {
    return [0, 0]
  }

  let glucometerEnd = siteUsageStats.config.glucometerEndDate || moment().valueOf()

  // start calculating at the program start, or query start, whichever is later
  let start = Math.max(glucometerStart, siteUsageStats.queryStartTimestamp)

  // stop calculating at the program end, or query end, whichever is earlier
  let end = Math.min(glucometerEnd, siteUsageStats.queryEndTimestamp)

  return [start, end]
}

function getStartAndEndVitals(siteUsageStats: SiteUsageStats): [number, number] {
  let vitalsStart = siteUsageStats.config.vitalsStartDate || moment().valueOf()

  // eslint-disable-next-line prettier/prettier
  if (
    vitalsStart >
    moment()
      .subtract(1, 'days')
      .valueOf()
  ) {
    return [0, 0]
  }

  let vitalsEnd = siteUsageStats.config.vitalsEndDate || moment().valueOf()

  // eslint-disable-next-line prettier/prettier

  // start calculating at the program start, or query start, whichever is later
  let start = Math.max(vitalsStart, siteUsageStats.queryStartTimestamp)

  // stop calculating at the program end, or query end, whichever is earlier
  let end = Math.min(vitalsEnd, siteUsageStats.queryEndTimestamp)

  return [start, end]
}

export function calcMonthlyRevenue_bak(siteUsageStats: SiteUsageStats, forGlucometer: boolean): number {
  const REVENUE_PER_MONTH = siteUsageStats.config.monthlyRevenue // 75.0 // for now

  // eslint-disable-next-line prettier/prettier
  let tuple = forGlucometer ? getStartAndEndGlucometer(siteUsageStats) : getStartAndEndVitals(siteUsageStats)

  let start = tuple[0]
  let end = tuple[1]

  if (start >= end) {
    return 0
  }
  let months = Math.round((end - start) / ONE_DAY) / 30.0

  return REVENUE_PER_MONTH * months
}

export function getOneTimeGlucometerGatewayCost(siteUsageStats: SiteUsageStats): number {
  return 0 // for now
  //   const ONE_TIME_COST_PER_GATEWAY = siteUsageStats.config.oneTimeGlucometerGatewayCost // 100.0
  //   let gateways = siteUsageStats.gateways
  //
  //   let tuple = getStartAndEndGlucometer(siteUsageStats)
  //   let start = tuple[0]
  //   let end = tuple[1]
  //
  //   if (start >= end) {
  //     return 0
  //   }
  //
  //   return ONE_TIME_COST_PER_GATEWAY * gateways
}

export function calcTotalEmrCost(siteUsageStats: SiteUsageStats): number {
  if (!siteUsageStats.glucometerReadingCountsPerMonthByType) {
    return 0 // can be null if not active this month
  }

  let months = getSelectedYearMonthsArray(siteUsageStats.queryStartTimestamp, siteUsageStats.queryEndTimestamp)
  let total = 0
  for (let yearMonth of months) {
    // let monthTs = moment(yearMonth + '-01', 'YYYY-MM-DD').valueOf() * 1000
    // let startOfMonthTimestamp = monthTs
    // let roughEndOfMonthTimestamp = monthTs + ONE_DAY * 30
    //
    // let num = 0
    // // for (let thisSiteStats of this.siteStats) {
    // let tuple = getStartAndEndGlucometer(siteUsageStats)
    // let start = tuple[0]
    // let end = tuple[1]
    //
    // if (end != 0 && end < monthTs) {
    //   continue // don't add cost if the program already ended
    // }
    // if (start > roughEndOfMonthTimestamp) {
    //   continue // don't add cost if the program hasn't started yet
    // }
    let monthCosts = siteUsageStats.revenuesAndCosts[yearMonth]
    total += monthCosts?.monthlyEmrCost || 0
  }
  return total
}

export function calcOneTimeVitalSignGatewayRevenue(siteUsageStats: SiteUsageStats): number {
  const ONE_TIME_REVENUE_PER_GW = 0 // for now //siteUsageStats.config.oneTimeVitalsGatewayRevenue // 500
  let gateways = siteUsageStats.gateways

  let tuple = getStartAndEndVitals(siteUsageStats)
  let start = tuple[0]
  let end = tuple[1]

  if (start >= end) {
    return 0
  }

  return ONE_TIME_REVENUE_PER_GW * gateways
}

export function getOneTimeVitalsGatewayCost(siteUsageStats: SiteUsageStats): number {
  const ONE_TIME_COST_PER_GATEWAY = 0 // for now // siteUsageStats.config.oneTimeVitalsGatewayCost // 300.0
  let gateways = siteUsageStats.gateways

  let tuple = getStartAndEndVitals(siteUsageStats)
  let start = tuple[0]
  let end = tuple[1]

  if (start >= end) {
    return 0
  }

  return ONE_TIME_COST_PER_GATEWAY * gateways
}

export function getSelectedYearMonthsArray(start: number, end: number): string[] {
  let output = []

  let ts = start
  while (ts <= end) {
    ts += ONE_DAY // handle any timezone issues
    output.push(moment(ts).format('YYYYMM'))
    ts = moment(ts)
      .add(1, 'M')
      .startOf('month')
      .valueOf()
  }
  return output
}

export function calcOneTimeRevenuesPerMonth(
  siteUsageStats: SiteUsageStats,
  includeSales = true,
  includeInstallationFees = true
): Array<number> {
  return getSelectedYearMonthsArray(siteUsageStats.queryStartTimestamp, siteUsageStats.queryEndTimestamp).map(
    yearMonth => {
      if (!siteUsageStats.revenuesAndCosts) {
        return 0 // no revenues or costs for this site
      }
      let revenuesAndCost = siteUsageStats.revenuesAndCosts[yearMonth]
      return (
        (includeSales ? revenuesAndCost?.gatewaySales || 0 : 0) +
        (includeInstallationFees ? revenuesAndCost?.gatewayInstallationFees || 0 : 0)
      )
    }
  )
}

export function calcStripRevenuePerMonth(siteUsageStats: SiteUsageStats): Array<number> {
  return getSelectedYearMonthsArray(siteUsageStats.queryStartTimestamp, siteUsageStats.queryEndTimestamp).map(
    yearMonth => {
      if (!siteUsageStats.glucometerReadingCountsPerMonthByType || !siteUsageStats.revenuesAndCosts) {
        return 0 // no strip use, or no revenues or costs for this site
      }
      let readingCountsThisMonth = siteUsageStats.glucometerReadingCountsPerMonthByType[yearMonth]
      let count = readingCountsThisMonth?.totalCount || 0
      let stripRevenue = siteUsageStats.revenuesAndCosts[yearMonth]?.glucometerStripRevenue || 0
      return count * stripRevenue // siteUsageStats.config.glucometerStripRevenue
    }
  )
  // return Object.values(siteUsageStats.glucometerReadingCountsPerMonthByType).map((count: number) => {
  //   return count * siteUsageStats.config.glucometerStripRevenue
  // })
}
export function calcMonthlyRevenues(siteUsageStats: SiteUsageStats): Array<number> {
  return getSelectedYearMonthsArray(siteUsageStats.queryStartTimestamp, siteUsageStats.queryEndTimestamp).map(
    yearMonth => {
      if (!siteUsageStats.revenuesAndCosts) {
        return 0 // no revenues or costs for this site
      }
      let revenuesAndCost = siteUsageStats.revenuesAndCosts[yearMonth]
      return revenuesAndCost?.monthlyRevenue || 0
    }
  )
}
export function calcMonthlyRevenueTotal(siteUsageStats: SiteUsageStats): number {
  return calcMonthlyRevenues(siteUsageStats).reduce((acc, val) => acc + val, 0)
}
